import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function GerenciadorAdminPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Gerencidor de Administradores'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CadastrarAdministrador'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Cadastrar Administrador'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerAdministradores'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver lista de Administradores'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'acessarPerfilsUser'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver perfil individual de Administradores'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'ConfigurarDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Configurar Departamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'HistoricosActividades'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Historicos de Actividades'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'HistoricosLogin'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Historicos de Login'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CentralImpressão'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Central de impressão'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'Access'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Access'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
